var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": ((_vm.getEventData.name) + " event participation registration")
    }
  }), _c('div', {
    staticClass: "homepage-wrap clearfix"
  }, [_c('div', {
    staticClass: "section-wrap bg-img register-banner"
  }, [_c('div', {
    staticClass: "max-width-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('ul', [_c('li', [_vm._v("Event")]), _c('li', [_vm._v(_vm._s(_vm.getEventData.name))])])])])])])]), _vm.loggedIn ? _c('section', {
    staticClass: "event-register events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_vm._m(0), !_vm.loggedIn ? [_vm._m(1)] : [!_vm.checkEligibility() ? _c('div', {
    staticClass: "register-text"
  }, [_c('p', {
    staticClass: "alert alert-warning text-center p-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.eventMessage))])])]) : _c('div', {
    staticClass: "register-text mb-0 ml-2"
  }, [!_vm.getEventData.ustatus || _vm.getEventData.ustatus === 'declined' ? [_vm.getEventData && _vm.getEventData.registration && _vm.getEventData.accept && _vm.checkEmptySlots() ? [_vm.getEventData ? _c('section', {
    staticClass: "container bg-white rounded border p-0"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "tab",
      "stepSize": "sm",
      "color": "#fbb814"
    },
    on: {
      "on-complete": _vm.submitApplication
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "DISCLAIMER"
    }
  }, [_c('div', {
    staticClass: "container p-5"
  }, [_vm._v(" Hello, registration for this event will require you to input personal details about your physique and performance. Please make every effort to enter accurate information to ensure fair racing. ")])]), _c('tab-content', {
    attrs: {
      "title": "PERSONAL DETAILS",
      "before-change": function () {
        return _vm.validateStep('personal');
      }
    }
  }, [_c('EventPersonalForm', {
    ref: "personal",
    attrs: {
      "user": _vm.getUserData,
      "dobRequired": _vm.getEventData.dob_required
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  })], 1), _vm.getEventData.identification ? _c('tab-content', {
    attrs: {
      "title": "IDENTITY VERIFICATION",
      "before-change": function () {
        return _vm.validateStep('identity');
      }
    }
  }, [_c('EventIdentificationForm', {
    ref: "identity",
    attrs: {
      "lazy": "true",
      "event": _vm.getEventData,
      "user": _vm.getUserData
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  })], 1) : _vm._e(), _vm.getEventData.device ? _c('tab-content', {
    attrs: {
      "title": "DEVICE DETAILS",
      "before-change": function () {
        return _vm.validateStep('device');
      }
    }
  }, [_c('EventDeviceForm', {
    ref: "device",
    attrs: {
      "lazy": "true",
      "event": _vm.getEventData,
      "user": _vm.getUserData
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  })], 1) : _vm._e(), _vm.getEventData.team ? _c('tab-content', {
    attrs: {
      "title": "TEAM",
      "before-change": function () {
        return _vm.validateStep('team');
      }
    }
  }, [_vm.getEventData ? _c('EventTeamForm', {
    ref: "team",
    attrs: {
      "lazy": "true",
      "event": _vm.event
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.getEventData.residence ? _c('tab-content', {
    attrs: {
      "title": "RESIDENCE INFORMATION",
      "before-change": function () {
        return _vm.validateStep('residence');
      }
    }
  }, [_c('EventResidenceForm', {
    ref: "residence",
    attrs: {
      "lazy": "true",
      "event": _vm.getEventData,
      "user": _vm.getUserData
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  })], 1) : _vm._e(), _vm.getEventData.otp ? _c('tab-content', {
    attrs: {
      "title": "PHONE VERIFICATION",
      "before-change": function () {
        return _vm.validateStep('otp');
      }
    }
  }, [_vm.getEventData ? _c('EventOtpForm', {
    ref: "otp",
    attrs: {
      "lazy": "true",
      "event": _vm.getEventData,
      "user": _vm.getUserData
    },
    on: {
      "on-validate": _vm.mergePartialModels
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _c('div', {
    staticClass: "text-danger bottom-error pb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.getErrors)
    }
  })], 1) : _vm._e()] : _vm._e()] : _vm._e()], 2)]], 2)])])]) : _c('Login'), _vm.getWinnersData.length > 0 && _vm.checkEligibility() ? _c('PriceWidget', {
    attrs: {
      "winners": _vm.getWinnersData,
      "eventData": _vm.getEventData,
      "showLink": true
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-left ml-2 registration-wizard"
  }, [_c('label', [_vm._v("REGISTER")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "register-text"
  }, [_c('p', {
    staticClass: "text-danger text-center"
  }, [_c('strong', [_vm._v("Please login to participate in the event")])])]);
}]

export { render, staticRenderFns }